import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import AuditsSection from "@components/Pages/Studio/SecurityPage/AuditsSection/AuditsSection"
import SecurityFeaturesSection from "@components/Pages/Studio/SecurityPage/SecurityFeaturesSection/SecurityFeaturesSection"
import TrustedBySection from "@components/Pages/Studio/SecurityPage/TrustedBySection/TrustedBySection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import ContentAssetSwitcher from "@components/WebsiteRevamp/Switchers/ContentAssetSwitcher/ContentAssetSwitcher"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import StudioIntegrations from "@jsons/studioSecurity.json"
import React from "react"

type Props = {}

const security = (props: Props) => {
	const pageData = getTranslatedPageData(StudioIntegrations, undefined, true)
	const list = getValueOrThrow(pageData.AdvancedSideAsset)

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath={"/about-us/security-and-compliance"}
			/>

			<FullWidthHeader
				data={{
					title: pageData.heroData?.[0].title,
					subtitle: pageData.heroData?.[0].subtitle,
				}}
				position={"left"}
			/>
			<section>
				<ContainerWrapper>
					<Separator size={128} />

					<ContentAssetSwitcher
						contentAssetProps={{
							withAspectRation: true,
						}}
						data={list[0]}
					/>
				</ContainerWrapper>
			</section>
			<SecurityFeaturesSection data={list[1]} />
			<AuditsSection data={list[2]} />
			<TrustedBySection data={list[3]} />
		</>
	)
}

export default security
